module.exports = "/static/assets/f1bf6cbb060ea625bdbcdc0163b1a292.png";